import React from 'react';
import clsx from 'clsx';

import styles from './Icon.module.scss';
import { ICON_COLOR } from '../api/portletConfiguration';

export default function Icon({
	className: classNameProp,
	size,
	textOn,
	icon = 'icon/close_grey.png',
	rotateDegree
}) {
	let folderPath = '';

	if (
		ICON_COLOR &&
		icon &&
		(icon.startsWith('icon') || icon.startsWith('services')) &&
		icon.indexOf('_blue') > 0
	) {
		folderPath = ICON_COLOR ? ICON_COLOR + '/' : '';
		icon = icon.replace('_blue', '');
	}

	const path = icon ? require('../images/' + folderPath + icon) : '';

	const className = clsx(
		styles.root,
		classNameProp,
		size && styles[size],
		textOn && styles[textOn]
	);

	const inlineStyle = rotateDegree
		? {
				transform: `rotate(${rotateDegree}deg)`
		  }
		: null;

	return path ? (
		<img
			className={className}
			src={path}
			style={inlineStyle}
			alt={'icon'}
		/>
	) : null;
}
